import React from 'react';

interface ModernCardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const ModernCard: React.FC<ModernCardProps> = ({ 
  children, 
  className = '', 
  style = {}, 
  onClick,
  onMouseEnter,
  onMouseLeave
}) => {
  const defaultStyle: React.CSSProperties = {
    background: '#ffffff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
    borderRadius: '1rem',
    padding: '1.5rem',
    transition: 'all 0.3s ease',
    cursor: onClick ? 'pointer' : 'default',
    ...style
  };

  return (
    <div 
      className={`position-relative overflow-hidden ${className}`}
      style={defaultStyle}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
};

export default ModernCard;
